<div class="support-wrapper">
  <app-toolbar />
  <section class="feature-shell">
    <h1>Support</h1>
    <p class="placeholder">Content coming soon.</p>
  </section>
  <app-footer />
</div>
